<div class="order-wks-component" (window:beforeunload)="ngOnDestroy()">
  <div class="component-header">
    <div>{{ title }}
      <span>{{ filtersDescription | uppercase }}</span>
    </div>
    <div class="icons gridster-ignore-drag d-flex">
      <div *ngIf="account" class="toggle-selectors" (click)="toggleDisplaySelectors()">
        <mat-icon class="icons-filter" svgIcon="filter"></mat-icon>
      </div>
      <mat-icon *ngIf="!newWindow && showExpandCard" svgIcon="expand" (click)="openNewWindow()"></mat-icon>
      <mat-icon disableWksChange *ngIf="!newWindow" svgIcon="close" (click)="removeItemFromWorkspace()"
        matTooltipPosition="above" [matTooltip]="removeFromWksTooltip">
      </mat-icon>
    </div>
  </div>
  <app-spinner-loading *ngIf="loading"></app-spinner-loading>
  <div *ngIf="!loading" class="component-container gridster-ignore-drag">
    <div class="row row-content">
      <div class="col-12 p-0 container-order-wks d-flex flex-column">
        <div *ngIf="!account" class="not-logged-div">
          <span>{{msgOfflineNegotiation}}</span>
        </div>
        <div class="show-selectors" [ngClass]="{'hide' : !showSelectors }">
          <div *ngIf="account" class="row-Selectors d-flex align-items-center">
            <div class="input-auto-complete">
              <app-auto-complete [placeHolderSetter]="'ativo'" [hideCompany]='true' [symbolAutoComplete]="model.symbol"
                #issuingAsset id="issuingAsset" (rawInformation)="checkForBlank($event)"
                (onsymbolChanged)="selectAsset($event)"></app-auto-complete>
            </div>
            <mat-form-field *ngFor="let filter of filters.properties">
              <mat-select panelClass="order-wks-select" placeholder="{{filter.label}}"
                [(ngModel)]="filters.valuesSelected[filter.field]" (ngModelChange)="applyFilter($event, filter.field)">
                <mat-option *ngFor="let item of filters.values[filter.field]" value="{{item.dailyFilter}}">{{item.desc}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="grid-section flex-fill">
          <app-grid-order *ngIf="account" [filters]="filters.valuesSelected" [showStrategies]="showStrategies"
            (gridReady)="onGridReady($event)">
          </app-grid-order>
        </div>
      </div>
    </div>
    <div *ngIf="account" class="col-12 d-flex align-items-center footer-orders">
      <div class="col-3 d-flex justify-content-center">
        <span>Total: </span>
        <span class="order-quantity">{{quantityOrder.total}}</span>
      </div>
      <div class="col-3 d-flex justify-content-center">
        <span>Abertas: </span>
        <span class="order-quantity">{{quantityOrder.open}}</span>
      </div>
      <div class="col-3 d-flex justify-content-center">
        <span class="executed">Executadas: </span>
        <span class="order-quantity">{{quantityOrder.executed}}</span>
      </div>
      <div class="col-3 d-flex justify-content-center">
        <span class="refused">Rejeitadas: </span>
        <span class="order-quantity">{{quantityOrder.refused}}</span>
      </div>
    </div>
  </div>
</div>
<div (window:beforeunload)="closeSheet()"></div>
